import React from "react";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';

class WhyShopee extends React.Component {
  render() {
    const { message , canAnimation = true} = this.props
    return (
      <>
        <ul className="img-introduce-wrapper">
          {
            message.list.map((item, index) => (
              <ReactWOW animation={canAnimation ? 'fadeInUp' : ''} delay={`${index * 0.1}s`} key={item.title || index}>
                <li className="introduce-item">
                  { item.img ? <img className="introduce-img" src={item.img} alt={item.img} /> : null }
                  <div className="introduce-content">
                    <p className="title">{$t(item.title)}</p>
                    {
                      Array.isArray(item.desc)
                      ? item.desc.map(desc => <p className="paragraph" key={desc}>{$t(desc)}</p>)
                      : <p className="paragraph" dangerouslySetInnerHTML={{__html: $t(item.desc)}}></p>
                    }
                  </div>
                </li>
              </ReactWOW>
            ))
          }
        </ul>
      </>
    );
  }
}

export default WhyShopee;
